import { inject, InjectionKey, provide } from 'vue'

export type ComponentCommentOpenPayload = {
    id?: number,
    text: string,
    attachment?: File
}

export type ComponentCommentModalActions = {
    openComment: (payload?: ComponentCommentOpenPayload) => void
}

export const ComponentCommentModalInjectionKey: InjectionKey<ComponentCommentModalActions> = Symbol(
    'ComponentCommentModalInjectionKey',
)

export const useComponentCommentModal = () => {
    return inject(ComponentCommentModalInjectionKey)
}

export const provideComponentCommentModal = (actions: ComponentCommentModalActions) =>
    provide(ComponentCommentModalInjectionKey, actions)
